var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"single-page search-page",attrs:{"id":"search-page"}},[_c('PageHeader'),_c('FilteredPostsList',{key:"search-filters",attrs:{"filters":"","taxonomy":"postTypes","postType":"postTypes","search":"","searchPlaceholder":"Søk på nettsiden"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }